import { render } from "./SearchOrders.vue?vue&type=template&id=50a8355a&scoped=true&ts=true"
import script from "./SearchOrders.vue?vue&type=script&lang=ts"
export * from "./SearchOrders.vue?vue&type=script&lang=ts"

import "./SearchOrders.vue?vue&type=style&index=0&id=50a8355a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a8355a"]])

export default __exports__